import { CamposGenericos } from "./camposGenericos";
import { PedidoVentaCabecera } from "./pedidoVentaCabecera";

export class PedidoVentaItem extends CamposGenericos {

     cantidad: number;
     cultivo: string;
     descuentoCategoria: number;
     descuentoDiscrecional: number;
     idCompania: string;
     idCultivo: string;
     idDivision: string;
     idLote: string;
     idPais: string;
     idPlanta: string;
     idProducto: string;
     idSalesOrg: string;
     idTipoOrden: string;
     nroLinea: number;
     nroPedido: number;
     porcentajeDiscrecional: number;
     porcentajeRecargo: number;
     precioFinal: number;
     precioKGL: number;
     precioUnitarioFinal: number;
     precioUnitarioLista: number;
     producto: string;
     recargo: number;
     recargoLocal: number;
     tipoOrden: string;
     total: number;
     totalLocal: number;
     totalDescuento: number;
     totalPrecioKGL: number;
     cantidadDisponible:number;
     cuotaDistribuidorMesyAnio: string;
     unidadesPallet:number;
     fechaEntrega: Date;

     public constructor(init?: Partial<PedidoVentaCabecera>) {
          super();
          Object.assign(this, init);
     }

}